// src/categories/exercises.js

const KEY = "exercises";
const TITLE = "Exercise Sensations";
const SUBTITLE = "An Aching Body Sensation";
const MAINWORD = "Aching Body";
const MAINWORDS = "aching bodies";
const MIN_ONLINE = 3;
const MAX_ONLINE = 15;


const SENSATIONS = [
  "MUSCLE BURN",
  "HEAVY BREATHING",
  "RACING HEART",
  "SHAKY MUSCLES",
  "SWEATING",
  "TIRED LEGS",
  "LIGHT SORENESS",
  "LOSS OF BREATH CONTROL",
  "WARMTH IN MUSCLES",
  "ELEVATED HEART RATE",
  "I GIVE UP",
  "NEED TO STOP",
  "DRY MOUTH",
  "MUSCLE PUMP",
  "LOW ENERGY AT START",
//   "INCREASED FOCUS",
  "BODY FEELS HEAVY",
  "WOBBLY LEGS AFTER SETS",
  "CAN’T LIFT AS HEAVY",
  "RAPID BREATH RECOVERY",
   "FEELING STUCK",
  "LOW ENERGY",
  "MENTAL FOG",
  "TENSION IN SHOULDERS",
  "RESTLESSNESS",
  "CHEST TIGHTNESS",
  "RACING THOUGHTS",
  "FEELING DISCONNECTED",
  "LOW MOTIVATION",
  "FEELING OVERWHELMED",
  "STOMACH KNOT",
  "LACK OF FOCUS",
  "NEGATIVE SELF TALK",
  "FAST BREATHING",
  "FEELING HEAVY",
  "INNER NOISE",
  "AGITATION",
  "EYE STRAIN",
  "LOW CONFIDENCE",
  "NEEDING GROUNDING"
];

const DISH_NAMES = {
  "MUSCLE BURN": "Lactic Fire",
  "HEAVY BREATHING": "Air Surge",
  "RACING HEART": "Heart Engine",
  "SHAKY MUSCLES": "Muscle Tremor",
  "SWEATING": "Heat Release",
  "TIRED LEGS": "Leg Fatigue",
  "LIGHT SORENESS": "Growth Ache",
  "LOSS OF BREATH CONTROL": "Breath Wave",
  "WARMTH IN MUSCLES": "Heat Build",
  "ELEVATED HEART RATE": "Cardio Peak",
  "I GIVE UP": "I Quit",
  "NEED TO STOP": "Effort Signal",
  "DRY MOUTH": "Hydration Call",
  "MUSCLE PUMP": "Pump Pressure",
  "LOW ENERGY AT START": "Slow Warmup",
//   "INCREASED FOCUS": "Flow State",
  "BODY FEELS HEAVY": "Gravity Load",
  "WOBBLY LEGS AFTER SETS": "Leg Quiver",
  "CAN’T LIFT AS HEAVY": "Load Limit",
  "RAPID BREATH RECOVERY": "Recovery Power",
  "FEELING STUCK": "Unstuck Move",
  "LOW ENERGY": "Energy Spark",
  "MENTAL FOG": "Brain Clear",
  "TENSION IN SHOULDERS": "Shoulder Release",
  "RESTLESSNESS": "Restless Reset",
  "CHEST TIGHTNESS": "Chest Open",
  "RACING THOUGHTS": "Mind Slow",
  "FEELING DISCONNECTED": "Reconnect Flow",
  "LOW MOTIVATION": "Motivation Kick",
  "FEELING OVERWHELMED": "Overwhelm Ease",
  "STOMACH KNOT": "Gut Calm",
  "LACK OF FOCUS": "Focus Narrow",
  "NEGATIVE SELF TALK": "Self-Kindness Switch",
  "FAST BREATHING": "Breath Reset",
  "FEELING HEAVY": "Lighten Up",
  "INNER NOISE": "Quiet Core",
  "AGITATION": "Agitation Release",
  "EYE STRAIN": "Eye Refresh",
  "LOW CONFIDENCE": "Confidence Lift",
  "NEEDING GROUNDING": "Ground Now",
  
};

const ENCOURAGEMENTS = {
  "MUSCLE BURN":
    "That burn comes from rising acidity (lactate and hydrogen ions) as muscles work hard — a normal part of energy production.",

  "HEAVY BREATHING":
    "Your breathing speeds up to bring in more oxygen and remove carbon dioxide as your muscles demand more energy.",

  "RACING HEART":
    "Your heart beats faster to pump more oxygen-rich blood to working muscles.",

  "SHAKY MUSCLES":
    "Shaking happens when muscle fibers fatigue and your nervous system recruits more fibers to keep you going.",

  "SWEATING":
    "Sweat cools your body as your temperature rises during exercise.",

  "TIRED LEGS":
    "Fatigue comes from energy stores being used and temporary buildup of metabolic byproducts in the muscles.",

  "LIGHT SORENESS":
    "Mild soreness is caused by tiny muscle fiber damage and inflammation from new or intense activity.",

  "LOSS OF BREATH CONTROL":
    "Your body is reaching higher intensity, where breathing becomes harder to match oxygen demand.",

  "WARMTH IN MUSCLES":
    "Increased blood flow and energy use raise muscle temperature, making them feel warm.",

  "ELEVATED HEART RATE":
    "Your heart rate rises to match the increased demand for oxygen and nutrient delivery.",

  "I GIVE UP":
    "This feeling comes from your brain sensing rising effort and trying to conserve energy, not actual physical failure.",

  "NEED TO STOP":
    "This signal reflects rising strain and fatigue — your body asking for awareness, not necessarily immediate danger.",

  "DRY MOUTH":
    "Dry mouth happens because breathing increases and saliva production decreases during exertion.",

  "MUSCLE PUMP":
    "Blood pools in working muscles, making them feel tight and full as nutrients and oxygen are delivered.",

  "LOW ENERGY AT START":
    "Your body needs a few minutes to increase blood flow, oxygen delivery, and nervous system activation.",

  "BODY FEELS HEAVY":
    "Heaviness comes from muscle fatigue and the effort required to repeatedly contract under load.",

  "WOBBLY LEGS AFTER SETS":
    "Muscle fatigue disrupts coordination, causing temporary instability after intense effort.",

  "CAN’T LIFT AS HEAVY":
    "Strength drops as energy stores decrease and muscle fibers fatigue during the workout.",

  "RAPID BREATH RECOVERY":
    "Faster recovery shows your heart and lungs are efficiently restoring oxygen levels and clearing carbon dioxide.",

  "FEELING STUCK":
    "This can happen when the nervous system is overloaded or fatigued, briefly reducing coordination and drive.",

  "LOW ENERGY":
    "Low energy reflects temporary depletion of fuel (like glycogen) or slower nervous system activation.",

  "MENTAL FOG":
    "Blood flow is prioritized to muscles during exercise, which can briefly affect mental clarity.",

  "TENSION IN SHOULDERS":
    "Stress and exertion can cause involuntary muscle tightening, especially in the upper body.",

  "RESTLESSNESS":
    "Adrenaline and increased nervous system activity can create a feeling of excess energy.",

  "CHEST TIGHTNESS":
    "Breathing muscles are working harder, which can create a tight sensation in the chest.",

  "RACING THOUGHTS":
    "Heightened arousal from exercise can temporarily speed up mental activity.",

  "FEELING DISCONNECTED":
    "Fatigue and stress can shift focus away from body awareness during exertion.",

  "LOW MOTIVATION":
    "Your brain reduces drive when effort feels high to protect energy reserves.",

  "FEELING OVERWHELMED":
    "High physical stress can activate the nervous system, making sensations feel intense.",

  "STOMACH KNOT":
    "Blood is redirected away from digestion to muscles, which can cause stomach discomfort.",

  "LACK OF FOCUS":
    "Fatigue and exertion can temporarily reduce attention and concentration.",

  "NEGATIVE SELF TALK":
    "Mental resistance increases as effort rises, reflecting the brain’s attempt to limit strain.",

  "FAST BREATHING":
    "Your breathing rate increases to meet oxygen demand and regulate blood pH.",

  "FEELING HEAVY":
    "This sensation comes from muscle fatigue and reduced efficiency during prolonged effort.",

  "INNER NOISE":
    "Heightened nervous system activity can increase internal awareness and mental chatter.",

  "AGITATION":
    "Adrenaline release during exercise can create a feeling of restlessness or irritability.",

  "EYE STRAIN":
    "Focus and tension can cause the eye muscles to work harder during effort.",

  "LOW CONFIDENCE":
    "As effort rises, the brain may increase doubt signals to discourage further exertion.",

  "NEEDING GROUNDING":
    "High physical and nervous system activation can make your body seek stability and control."
};

export default { KEY, TITLE, SUBTITLE, MAINWORD, MAINWORDS, MIN_ONLINE, MAX_ONLINE, SENSATIONS, DISH_NAMES, ENCOURAGEMENTS };
